import React from "react";

const DaySelector = ({ days, setDays }) => {
  return (
    <div className="flex items-center gap-1.5 mm:gap-3">
      <button
        onClick={() => setDays("week")}
        className={`${
          days === "week"
            ? "bg-themeSecondColor bg-opacity-80 text-white"
            : "text-black"
        } flex items-center justify-center text-sm font-medium p-2 mm:p-3 rounded-xl  h-8`}
        type="button"
      >
        Haftalık
      </button>
      <button
        onClick={() => setDays("night")}
        className={`${
          days === "night" ? "bg-themeSecondColor text-white" : "text-black"
        } flex items-center justify-center  text-sm font-medium p-2 mm:p-3 rounded-xl  h-8`}
        type="button"
      >
        Gecelik
      </button>
    </div>
  );
};

export default DaySelector;
